module.exports = __webpack_public_path__ + "assets/69c0f8e7dc57d04974be03ab17750cec.svg";